export default __webpack_public_path__ + "static/residential-21d1d2721252a909b8a3b38a3fdb1405.png";